import React, {useMemo, useContext} from "react"

interface RouteContext {
  app: string
  apps: Record<string, string>
  appPath: string
}

const context = React.createContext<RouteContext | null>(null)

interface Props {
  children: React.ReactNode
  app: string
  apps: Record<string, string>
}

export const ContextRouteProvider = React.memo(function ContextRouteProviderC({children, app, apps}: Props) {
  const value = useMemo(
    () => ({
      app,
      apps,
      appPath: apps[app]
    }),
    [app, apps]
  )

  return <context.Provider value={value}>{children}</context.Provider>
})

export function useAppRouteContext(): RouteContext {
  const c = useContext(context)
  if (!c) throw new Error("useAppRouteContext must be used inside of ContextRouteProvider")
  return c
}
